<div class="grid p-fluid">
  <form [formGroup]="resultForm" class="col-12 lg:col-12 md:col-12 form-group" novalidate>
    <div class="p-fluid p-formgrid grid">
      <div class="p-field col-12 md:col-6">
        <span class="p-float-label size_cent form-margin">
          <input formControlName="name" class="p-inputtext size_cent" pInputText type="text" />
          <label>{{'Superv_Name' | translate}} *</label>
        </span>
        <span class="p-float-label size_cent form-margin">
          <input formControlName="label" class="p-inputtext size_cent" pInputText type="text" />
          <label>{{'Superv_Lab' | translate}} *</label>
        </span>
        <div class="p-float-label size_cent form-margin">
          <div>{{'Visibility' | translate}} *</div>
          <p-dropdown
            formControlName="visibility"
            [options]="listVisibility"
            (onChange)="onChangeVisibility($event)"
            placeholder="{{'Sel_TQuer' | translate}}"
            [style]="{ width: '100%' }"
          ></p-dropdown>
        </div>
      </div>
      <div class="p-field col-12 md:col-6">
        <div>{{'Desc' | translate}}</div>
        <textarea formControlName="desc" rows="4" cols="57" pInputTextarea></textarea>
      </div>
    </div>
    <div class="p-fluid p-formgrid grid">
      @if (visibility === 0) {
        <div class="col-6"></div>
      }
      @if (visibility === 1) {
        <div class="col-6">
          <div class="center-text">{{'List_Grp' | translate}}</div>
          <p-listbox
            formControlName="groupListUsed"
            [options]="groupList"
            multiple="multiple"
            checkbox="checkbox"
            [filter]="true"
            optionLabel="label"
            optionValue="value"
            [style]="{ width: '100%' }"
            [listStyle]="{ width: '100%', height: '35vh' }"
            scrollHeight="35vh"
            >
          </p-listbox>
        </div>
      }
      @if (visibility === 2) {
        <div class="col-6">
          <div class="center-text">{{'List_Usr' | translate}}</div>
          <p-listbox
            formControlName="userListUsed"
            [options]="userList"
            multiple="multiple"
            checkbox="checkbox"
            [filter]="true"
            optionLabel="label"
            optionValue="value"
            [style]="{ width: '100%' }"
            [listStyle]="{ width: '100%', height: '35vh' }"
            scrollHeight="35vh"
            >
          </p-listbox>
        </div>
      }
      <div class="col-6">
        <bskselect
          #bskselect
          [basketList]="basketList"
        >
        </bskselect>
      </div>
    </div>
  </form>
</div>

<div class="col-12 lg:col-12 md:col-12 align-right">
  @if (resultForm.controls['id'].value) {
    <button
      (click)="deleteItem()"
      class="p-button-danger p-button p-component p-button-text-only blockBottom margin"
      >
      {{'Delete' | translate}}
    </button>
  }
  <button
    (click)="cancel()"
    type="button"
    class="p-button-primary p-button-outlined p-button p-component p-button-text-only btn-square margin"
    >
    {{'Cancel' | translate}}
  </button>
  <button
    (click)="validate()"
    type="button"
    class="p-button p-component p-button-text-only btn-square margin"
    >
    {{'Valid' | translate}}
  </button>
</div>
